import { AccountTypeEnum } from '.spec/self-care/tsTypes';

import { AccountInfo } from './customerContext/types';

export const IS_NON_PROD = process.env.TARGET_ENV !== 'prod' && typeof window !== 'undefined';

export function getJarabotDelay(lsKey: string, fallback: number): number {
	if (!IS_NON_PROD) return fallback;
	const raw = localStorage.getItem(lsKey);
	const parsed = raw !== null ? parseInt(raw, 10) : NaN;
	return Number.isNaN(parsed) ? fallback : parsed;
}

export function getFlag(key: string): boolean {
	try {
		return sessionStorage.getItem(key) === '1';
	} catch {
		return false;
	}
}

export function setFlag(key: string): void {
	try {
		sessionStorage.setItem(key, '1');
	} catch {
		// sessionStorage not available — continue without persistence
	}
}

export function clearFlag(key: string): void {
	try {
		sessionStorage.removeItem(key);
	} catch {
		// sessionStorage not available — continue without persistence
	}
}

// NON-PROD-only test overrides persisted in localStorage. Mirrors the get/set/clear
// flag helpers above so the gate simulator (writer) and the jarabot hooks (reader)
// share one abstraction instead of duplicating raw localStorage keys.
export const TEST_OVERRIDE_KYC_VERIFIED = '__jarabot_test_kyc_verified';

export function getTestOverride(key: string): string | null {
	if (!IS_NON_PROD) return null;
	try {
		return localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function setTestOverride(key: string, value: string | null): void {
	if (!IS_NON_PROD) return;
	try {
		if (value === null) {
			localStorage.removeItem(key);
		} else {
			localStorage.setItem(key, value);
		}
	} catch {
		// localStorage not available — continue without persistence
	}
}

export const toIsoDate = (value?: string | null): string | undefined =>
	value ? value.slice(0, 10) : undefined;

export const capNames = (names: ReadonlyArray<string | null | undefined>, cap: number): string[] =>
	names.filter((name): name is string => !!name).slice(0, cap);

export const accountPackage = (
	accountType?: AccountTypeEnum | null
): AccountInfo['package'] | undefined => {
	if (accountType == null) return undefined;
	return accountType === AccountTypeEnum.TRY_IT ? 'mini' : 'maxi';
};
